module.exports = __webpack_public_path__ + "img/assessment.da89d322.png";